import { strings } from '../context/LanguageContext/strings'

export const pushNotification = {
    getPushNotificationsHeadCells: () => [
        { id: 'title', label: strings.CONTENT_TITLE, draggable: false, width: '17%' },
        {
            id: 'start_date',
            label: strings.SEND_TIME,
            draggable: false,
            width: '12%',
            sortable: true,
        },
        { id: 'state', label: strings.AUDIENCE, draggable: false, width: '12%' },
        { id: 'total_sent_count', label: strings.SENT, draggable: false, width: '12%' },
        { id: 'status', label: strings.STATUS, draggable: false, width: '12%', sortable: true },
        {
            id: 'created',
            label: strings.DATE_CREATED,
            draggable: false,
            width: '12%',
            sortable: true,
        },
        { id: 'action', label: strings.ACTION, draggable: false, width: '7%' },
    ],
    getPushNotificationStatusFields: () => [
        { value: 'Not Started', display: strings.NOT_STARTED },
        { value: 'Incomplete', display: strings.INCOMPLETE },
        { value: 'Complete', display: strings.COMPLETE },
        { value: 'Scheduled', display: strings.SCHEDULED },
        { value: 'Sent', display: strings.SENT },
    ],
    pushNotificationFilterLabels: [
        { key: 'pushNotificationId', label: strings.pushNotificationId, after: 'comma' },
        { key: 'createdBy', label: strings.CREATED_BY, after: 'comma' },
        { key: 'lastModifiedBy', label: strings.LAST_MODIFIED, after: 'comma' },
        { key: 'status', label: strings.STATUS, after: 'comma' },
        { key: 'audienceSize', label: strings.audienceSize, after: 'hyphen' },
        { key: 'date_range', label: strings.dateRange, after: 'hyphen' },
    ],
    getPushNotificationSections: () => [
        { step: 1, title: strings.MESSAGE, key: 'message' },
        { step: 2, title: strings.SCHEDULING, key: 'scheduled' },
        { step: 3, title: strings.AUDIENCE, key: 'state' },
    ],
    rangeSliderMarks: [
        {
            value: 0,
            label: '0k',
        },
        {
            value: 100,
            label: '100k',
        },
    ],
    getMapNotificationStatus: status => {
        const mappedStatuses = {
            'Not Started': {
                value: 'Not Started',
                display: strings.NOT_STARTED,
            },
            Incomplete: {
                value: 'Incomplete',
                display: strings.INCOMPLETE,
            },
            Ready: {
                value: 'Complete',
                display: strings.COMPLETE,
            },
            Scheduled: {
                value: 'Scheduled',
                display: strings.SCHEDULED,
            },
            Completed: {
                value: 'Sent',
                display: strings.SENT,
            },
        }

        const { value, localization } = mappedStatuses[status] || {}

        return { value, localization }
    },
}
